import { render, staticRenderFns } from "./SetupData.vue?vue&type=template&id=7710211d"
import script from "./SetupData.vue?vue&type=script&lang=js"
export * from "./SetupData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports